"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DeliverySettlementStatus = void 0;
/**
 * Computed delivery settlement status for an order, derived at search time.
 *
 * Uses the heuristic: an order has a pending delivery payment when
 * externalDelivery=true AND deliveryPrice>0 AND paidAmount < totalWithDelivery.
 *
 * pending  - external delivery cost exists and has not been fully covered by installments
 * settled  - no external delivery, no delivery price, or installments fully cover the total
 */
var DeliverySettlementStatus;
(function (DeliverySettlementStatus) {
    DeliverySettlementStatus["PENDING"] = "pending";
    DeliverySettlementStatus["SETTLED"] = "settled";
})(DeliverySettlementStatus || (exports.DeliverySettlementStatus = DeliverySettlementStatus = {}));
